import { useState } from 'react'

export function useTabs<TabValue>(initialValue: TabValue): [TabValue, (event: any, value: TabValue) => void] {
  const [value, setValue] = useState(initialValue)

  const handleChange = (event: any, newValue: TabValue) => {
    setValue(newValue)
  }

  return [value, handleChange]
}
